import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'

import { ContextHolder } from '@frontegg/react'
import { ContextOptions } from '@frontegg/types/ContextOptions'
import { FunctionComponent } from 'react'
import LogoutIcon from '@mui/icons-material/Logout'

interface Props {
  handleClose: Function
}
const LogoutMenuItem: FunctionComponent<Props> = ({ handleClose }) => {
  const logOut = () => {
    handleClose()
    const context: ContextOptions = ContextHolder.getContext()
    window.location.href = `${context.baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location.href}`
  }

  return (
    <MenuItem onClick={logOut} data-testid="logout">
      <ListItemIcon>
        <LogoutIcon fontSize="small" sx={{ color: 'primary.main' }} />
      </ListItemIcon>
      <ListItemText>Sign out</ListItemText>
    </MenuItem>
  )
}

export default LogoutMenuItem
